/**
 * Mock catalog + roles for permissions editor until / while API is unavailable.
 * Shape aligns with API: modules have id, parentModuleId, moduleName, path.
 */

export const MOCK_STANDARD_ACTIONS = [
  { code: 'view', labelKey: 'dashboard.configuration.actions.view', descKey: 'dashboard.configuration.actions.viewDesc', deps: [] },
  { code: 'search', labelKey: 'dashboard.configuration.actions.search', descKey: 'dashboard.configuration.actions.searchDesc', deps: [] },
  { code: 'create', labelKey: 'dashboard.configuration.actions.create', descKey: 'dashboard.configuration.actions.createDesc', deps: ['view'] },
  { code: 'update', labelKey: 'dashboard.configuration.actions.update', descKey: 'dashboard.configuration.actions.updateDesc', deps: ['view'] },
  { code: 'delete', labelKey: 'dashboard.configuration.actions.delete', descKey: 'dashboard.configuration.actions.deleteDesc', deps: ['view', 'search'] },
];

export const MOCK_MODULES = [
  { id: '1', parentModuleId: null, moduleNameKey: 'dashboard.configuration.modules.dashboard', path: '/dashboard/' },
  { id: '2', parentModuleId: null, moduleNameKey: 'dashboard.configuration.modules.packages', path: '/dashboard/packages/' },
  { id: '21', parentModuleId: '2', moduleNameKey: 'dashboard.configuration.modules.pkgLoad', path: '/dashboard/packages/load' },
  { id: '22', parentModuleId: '2', moduleNameKey: 'dashboard.configuration.modules.pkgTracking', path: '/dashboard/packages/tracking' },
  { id: '3', parentModuleId: null, moduleNameKey: 'dashboard.configuration.modules.platforms', path: '/dashboard/platforms/' },
  { id: '31', parentModuleId: '3', moduleNameKey: 'dashboard.configuration.modules.platGeneral', path: '/dashboard/platforms/general' },
  { id: '4', parentModuleId: null, moduleNameKey: 'dashboard.configuration.modules.clients', path: '/dashboard/clients' },
  { id: '5', parentModuleId: null, moduleNameKey: 'dashboard.configuration.modules.companies', path: '/dashboard/companies' },
];

export const MOCK_CUSTOM_BY_MODULE = {
  31: [
    { code: 'open_door_remote', labelKey: 'dashboard.configuration.custom.openDoor', descKey: 'dashboard.configuration.custom.openDoorDesc', deps: ['view'] },
  ],
  5: [
    { code: 'update_company_logo', labelKey: 'dashboard.configuration.custom.updateLogo', descKey: 'dashboard.configuration.custom.updateLogoDesc', deps: ['view', 'update'] },
  ],
};

export const MOCK_ROLES = [
  { id: 1, nameKey: 'dashboard.configuration.roles.superAdmin', abbr: 'SA', color: '#ef4444', system: true, userCount: 2 },
  { id: 2, nameKey: 'dashboard.configuration.roles.admin', abbr: 'AD', color: '#f59e0b', system: false, userCount: 8 },
  { id: 3, nameKey: 'dashboard.configuration.roles.operator', abbr: 'OP', color: '#3b82f6', system: false, userCount: 24 },
  { id: 4, nameKey: 'dashboard.configuration.roles.readonly', abbr: 'RO', color: '#10b981', system: false, userCount: 15 },
];

function emptyPermsForRoles(roles, modules) {
  const perms = {};
  roles.forEach((r) => {
    perms[String(r.id)] = {};
    modules.forEach((m) => {
      const mid = String(m.id ?? m.moduleId);
      perms[String(r.id)][mid] = {};
    });
  });
  return perms;
}

export function buildInitialMockPerms() {
  const perms = emptyPermsForRoles(MOCK_ROLES, MOCK_MODULES);
  const setAll = (rid, mid, codes, val) => {
    codes.forEach((c) => {
      perms[String(rid)][String(mid)][c] = val;
    });
  };

  // Super admin: todo en módulos mock
  MOCK_MODULES.forEach((m) => {
    const mid = String(m.id);
    const codes = [
      ...MOCK_STANDARD_ACTIONS.map((a) => a.code),
      ...(MOCK_CUSTOM_BY_MODULE[mid] || []).map((a) => a.code),
    ];
    setAll(1, mid, codes, true);
  });

  // Admin: paquetes + plataformas estándar
  ['21', '22', '31'].forEach((mid) => {
    MOCK_STANDARD_ACTIONS.forEach((a) => {
      perms['2'][mid][a.code] = true;
    });
  });
  perms['2']['31']['open_door_remote'] = true;

  // Operador: parcial
  ['21', '22'].forEach((mid) => {
    ['view', 'search', 'create'].forEach((c) => {
      perms['3'][mid][c] = true;
    });
  });

  // Solo lectura
  MOCK_MODULES.forEach((m) => {
    const mid = String(m.id);
    perms['4'][mid].view = true;
    perms['4'][mid].search = true;
  });

  return perms;
}
